import React, { Fragment } from 'react'
import { STATUS } from '../../Constants'
import UserRow from './UserRow'
import { useTranslation } from 'react-i18next'
import UserRowLoadding from './UserRowLoadding'

const AllUsersList = ({statusAllUsers ,allUsers }) => {

  // For Transaltion
  const {t} = useTranslation() ; 


  return (
    <div className='users-table'>

        <div className='table-head'>
            <div className='cell'><p>Name</p></div>
            <div className='cell'><p>Mobile</p></div>
            <div className='cell'><p>Expiration Date</p></div>
            <div className='cell'><p>Points</p></div>
            <div className='cell'><p>Status</p></div>
            <div className='cell'><p>Block/UnBlock</p></div>
            <div className='cell'><p>Remove</p></div>
        </div>

        <div className='table-body'>
          
            {
            statusAllUsers === STATUS.SUCCESS ? 
            allUsers.length > 0 ? 
            allUsers.map((item)=>{
            return (<UserRow key={item._id} id={item._id} role={item.role} email={item.email} name={item.username} image={item.img} block={item.isBlocked} mobile={item.mobileNumber} expirationDate={item.expiredAt} points={item.points} active={item.expired}  />)
            })
            :
            <h2>Users Not Found</h2>
            :
            ""
            }
            
            {
              statusAllUsers === STATUS.LOADDING ?
              <Fragment>
                <UserRowLoadding />
                <UserRowLoadding />
                <UserRowLoadding />
                <UserRowLoadding />
                <UserRowLoadding />
              </Fragment>
              :
              ""
            }
        </div>

</div>
  )
}

export default AllUsersList
